import { useEffect, useState } from "react";
import { useSelector, shallowEqual } from "umi";
import dailyFilterDefault from "@/pages/dashboard/filterPageComponents/overview/dailyFilterDefault";
import { getPcV3DailyCountryRegionPlatform } from "@/pages/dashboard/services/overview";
import { stringToFunction } from '@/pages/dashboard/utils/stringToJson';

const useData = (
  filterVal: any,
  filterLoading: boolean,
  api: string,
  extralParams: any,
  period: string,
  by_type: string,
  chartDataKey: string,
  tableDataKey: string,
  formatData?: ((res: any) => any) | string,
) => {
  const formVal = filterVal || dailyFilterDefault;
  const [data, setData] = useState<any>({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const gameCode = useSelector((state: any) => {
    return state?.dashboard?.currentGame?.game_code;
  }, shallowEqual);
  // 点击筛选器的时候
  useEffect(() => {
    if (!filterVal) return;
    if (!filterLoading) {
      getPcDailyCountryRegionPlatformDataFunc();
    }
  }, [formVal, by_type]);

  const getPcDailyCountryRegionPlatformDataFunc = () => {
    const { rangeTime: [start, end], diff, timeType, ...filters } = filterVal;

    const params = {
      game_code: gameCode,
      start_time: start,
      end_time: end,
      period,
      filters,
      by_type,
      ...(extralParams ? extralParams : {})
    };

    // 由于有些排行后端返回的数据不一样名称，所以这里加了一个配置，默认是'dwm'
    const configChartDataKey = chartDataKey || 'dwm_data_list';
    const configTableDataKey = tableDataKey || 'dwm_list';
    setLoading(true);
    getPcV3DailyCountryRegionPlatform(api, params).then((result: any) => {
      let resData = result;
      if (formatData) {
        try {
          resData = typeof formatData === 'string'
            ? stringToFunction(formatData)(result)
            : formatData(result);
        } catch (err) {
          console.error('CommonRankListCo formatData error:', err);
          resData = result;
        }
      }
      setError(false);
      setLoading(false);
      setData({
        chartData: resData?.[configChartDataKey] || [],
        tableData: resData?.[configTableDataKey] || [],
      });
    }).catch(() => {
      setError(true);
      setLoading(false);
    });
  };

  return {
    // nodata 不在此封装，因为可能是接口的个别项目nodata
    data,
    loading,
    error,
    getData: getPcDailyCountryRegionPlatformDataFunc
  };
};

export default useData;